import { render } from "./Card2.vue?vue&type=template&id=cd2af15c"
import script from "./Card2.vue?vue&type=script&lang=js"
export * from "./Card2.vue?vue&type=script&lang=js"

import "./Card2.vue?vue&type=style&index=0&id=cd2af15c&lang=css"

import exportComponent from "/Users/kimlong/Documents/Projects/Vuejs/adsota/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__